import * as React from 'react';
import {BaseIconProps} from '../../types';

export const BaseCopy: React.FC<BaseIconProps> = ({size, color}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 2.5H5C3.61929 2.5 2.5 3.61929 2.5 5V14C2.5 15.3807 3.61929 16.5 5 16.5H6V15H5C4.44772 15 4 14.5523 4 14V5C4 4.44772 4.44772 4 5 4H14C14.5523 4 15 4.44772 15 5V6H16.5V5C16.5 3.61929 15.3807 2.5 14 2.5ZM19 7.5H10C8.61929 7.5 7.5 8.61929 7.5 10V19C7.5 20.3807 8.61929 21.5 10 21.5H19C20.3807 21.5 21.5 20.3807 21.5 19V10C21.5 8.61929 20.3807 7.5 19 7.5ZM9 10C9 9.44771 9.44772 9 10 9H19C19.5523 9 20 9.44772 20 10V19C20 19.5523 19.5523 20 19 20H10C9.44771 20 9 19.5523 9 19V10Z"
        fill={color}
      />
    </svg>
  );
};
